import { Trans } from 'react-i18next';

import { Alert, Button, Column, Input, Row } from 'components/Blocks';
import { usePackageValueChange } from './changeValue.context';
import { CircleDollarIcon } from 'components/Icons';

import { useLang } from 'hooks/lang';

export function ConfirmationStep(): JSX.Element {
  const { t } = useLang();
  const { handleChange, state, dispatch } = usePackageValueChange();

  const targetValue = t('i-understand-typed');

  const canAdvance = targetValue === state.understandStatement;

  return (
    <Column>
      <Alert level="warning" title={t('warning')}>
        <Trans i18nKey="package-value-change-warning" />
      </Alert>

      <span className="select-none">
        <Trans i18nKey="package-value-understand" />
      </span>

      <Input
        value={state.understandStatement}
        name="understandStatement"
        onChange={handleChange}
        placeholder={targetValue}
      />

      <Row justifyContent="flex-end">
        <Button
          disabled={!canAdvance}
          variant="outlined"
          onClick={() => dispatch({ confirmed: true })}
        >
          <CircleDollarIcon />
          {t('change-value')}
        </Button>
      </Row>
    </Column>
  );
}
